import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
var Toggle = function Toggle(_ref) {
  var className = _ref.className,
    text = _ref.text,
    id = _ref.id,
    onClick = _ref.onClick,
    readOnly = _ref.readOnly;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, readOnly ? text : /*#__PURE__*/React.createElement("a", {
    id: "".concat(id, "-toggle-link"),
    role: "button",
    onClick: onClick,
    tabIndex: 0
  }, text));
};
Toggle.propTypes = {
  className: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  readOnly: PropTypes.bool
};
Toggle.defaultProps = {
  onClick: noop,
  readOnly: false
};
export default Toggle;